// Botão Flutuante de Compra - Versão que Funciona com Releasit
window.addEventListener('load', function() {
  setTimeout(function() {
    // Procura o botão original ANTES de criar o flutuante
    let originalButton = null;
    const allButtons = document.querySelectorAll('button');
    
    allButtons.forEach(function(btn) {
      const text = btn.textContent.trim();
      if (text.includes('COMPRAR AHORA') && text.includes('Paga al recibir')) {
        originalButton = btn;
        console.log('Botão Releasit encontrado:', btn);
      }
    });
    
    if (!originalButton) {
      console.log('Botão Releasit não encontrado');
      return;
    }
    
    // Cria a barra flutuante
    const stickyBar = document.createElement('div');
    stickyBar.className = 'sticky-atc-bar';
    stickyBar.innerHTML = `
      <button class="sticky-atc-button shake-animation" type="button">
        🛒 COMPRAR AHORA
      </button>
    `;
    
    document.body.appendChild(stickyBar);
    
    // Mostra a barra ao rolar
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 300) {
        stickyBar.classList.add('visible');
      } else {
        stickyBar.classList.remove('visible');
      }
    });
    
    // Quando clicar no botão flutuante
    const stickyButton = stickyBar.querySelector('.sticky-atc-button');
    
    stickyButton.onclick = function() {
      console.log('Tentando clicar no botão Releasit...');
      
      // Método 1: Click direto
      originalButton.click();
      
      // Método 2: Simular eventos do mouse
      setTimeout(function() {
        const rect = originalButton.getBoundingClientRect();
        const x = rect.left + rect.width / 2;
        const y = rect.top + rect.height / 2;
        
        ['mousedown', 'mouseup', 'click'].forEach(function(eventType) {
          const event = new MouseEvent(eventType, {
            view: window,
            bubbles: true,
            cancelable: true,
            clientX: x,
            clientY: y
          });
          originalButton.dispatchEvent(event);
        });
      }, 100);
      
      // Método 3: Rolar até o botão original e clicar
      setTimeout(function() {
        originalButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function() {
          originalButton.click();
        }, 500);
      }, 200);
      
      console.log('Cliques enviados');
    };
    
  }, 3000);
});
